module.exports = new __parcel__URL__("community--light.77e695b7.svg").toString();